import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Slide,
  Stack,
  Typography,
} from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import { useTranslation } from "react-i18next";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const SessionTimeoutDialog = ({ open, onLogout, onContinue }) => {
  const {t} = useTranslation();
  return (
    <Dialog open={open} TransitionComponent={Transition}>
      <DialogTitle>{t("Session Timeout")}</DialogTitle>
      <IconButton disableRipple>
        <WarningIcon sx={{ fontSize: "8rem", color: "#DCC207" }} />
      </IconButton>
      <DialogContent>
        <DialogContentText>
          <Typography variant="h6">
            {t("The current session is about to expire soon Would you like to continue the session?")}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Stack spacing={2} direction="row">
          <Button
            variant="contained"
            className="sessionLogout"
            onClick={onLogout}
          >
            {t("Logout")}
          </Button>
          <Button
            variant="contained"
            className="activeYesButton"
            onClick={onContinue}
          >
            {t("Continue Session")}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
export default SessionTimeoutDialog;
